<template>
    <v-container fluid class="main-page-shell pa-0">
        <v-layout align-center justify-center>
            <v-flex lg12 md12 sm12 xsl2>
                <ncoc-calendar :key="calendarKey"></ncoc-calendar>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	export default {
		components: {
			'ncoc-calendar': () => import('@/components/MainCalendar.vue'),
		},
		data: function () {
			return {}
		},
		computed: {
			calendarKey() {
				return this.$store.getters.getCalendarKey
			},

		},
		async created() {
			document.querySelector('html').style.overflowY = 'auto';
		},
		methods: {}
	}
</script>
<style scoped>.main-page-shell{min-height:100%}</style>
